import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  Col,
  Input,
  Modal,
  Row,
  Table,
} from "reactstrap";
import {
  GET_AREA_FROM_BOOKING,
  GET_RP_OVERUSE_CODE,
  GET_RP_OVERUSE_SHIPPER,
  GET_SHIPPER,
  GET_SHIPPER_BY_BOOKING,
} from "../../../helpers/url_api_constant";
import React, { useEffect, useState } from "react";
import Select, { OptionProps, components } from "react-select";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import BootstrapTable from "react-bootstrap-table-next";
import OveruseByContact from "./OveruseByContact";
import OveruseByShipper from "./OveruseByShipper";
import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SectionSectionCapacity(props) {
  //   console.log(props);
  const dispatch = useDispatch();

  useEffect(() => {}, [props.summaryReportPid]);
  useEffect(() => {}, [props.date]);

  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }

  return (
    <Row>
      <Col sm="12">
        <Card className="mb-1" style={{ backgroundColor: "#0087ff1a" }}>
          <CardBody>
            <Row className="mt-0">
              <Col sm="12">
                <h5
                  className="mb-0 sm-0 font-size-18"
                  style={{ color: "#46FCFF" }}
                >
                  Capacity Overuse
                </h5>
              </Col>
            </Row>

            <Row className="mt-2">
              <hr style={{ color: "#46FCFF" }} />
            </Row>

            <Row className="mt-0">
              <Col
                sm="6"
                className="d-flex align-items-center justify-content-start"
              ></Col>

              <Col
                sm="6"
                className="d-flex align-items-center justify-content-end"
              >
                <h5
                  className="mb-0 sm-0 font-size-15"
                  style={{ color: "#46FCFF" }}
                >
                  {" "}
                  Unit : BBTU
                </h5>
              </Col>
            </Row>
            {props.summaryReportPid && (
              <>
                <OveruseByShipper
                  date={props.date}
                  summaryReportPid={props.summaryReportPid}
                />
                <OveruseByContact
                  date={props.date}
                  summaryReportPid={props.summaryReportPid}
                />
              </>
            )}
            {/* <Row className="mt-4">
              <Col lg="6">
                <div className="table-responsive">
                  hover-table-highlight
                  <Table className="table table-bordered mb-0">
                    <thead>
                      <tr>
                        
                        <th
                          style={{
                            backgroundColor: "#556ee64a",
                            color: "#7AE3F7",
                            textAlign: "center",
                            width: "100%",
                          }}
                        >
                          Remark
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ color: "#FFFFFF", textAlign: "center" }}>
                      <tr>
                        <td>
                          <Col sm={12}>
                            <Input
                              placeholder="Remark"
                              type="textarea"
                              rows="3"
                              style={{
                                border: "solid 1px #FFFFFF",
                                color: "#FFFFFF",
                              }}
                              className="form-control"
                              onChange={(e) => setCreateModel(
                                {
                                  ...createModel,
                                  UPLOAD_DESC: e.target.value
                                })
                              }
                              value={createModel.UPLOAD_DESC}
                            />
                          </Col>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </Col>
            </Row> */}
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

SectionSectionCapacity.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default SectionSectionCapacity;
